"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateProfileAccount = exports.register = exports.getProfileAccount = exports.getAccountOwners = exports.getAccount = exports._verifyUser = exports._updateProfile = exports._updatePassword = exports._updateNotificationSettings = exports._updateBillingPreference = exports._resendEmail = exports._checkUserStatus = exports._changeEmail = void 0;
var _environment = _interopRequireDefault(require("../../environment"));
var _constants = require("../../util/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// import fetch from '../../util/fetch';
require('isomorphic-fetch');
var accountUrl = _environment.default.ACCOUNT.accountUrl;
var verifyUrl = _environment.default.REGISTRATION.verifyUrl;
var registerUrl = _environment.default.REGISTRATION.registerUrl;
var checkStatusUrl = _environment.default.REGISTRATION.checkStatusUrl;
var resendEmailUrl = _environment.default.REGISTRATION.resendEmailUrl;
var changeEmailUrl = _environment.default.REGISTRATION.changeEmailUrl;
var profileAccountUrl = _environment.default.ACCOUNT.profileAccountUrl;
var accountOwnersURL = _environment.default.ACCOUNT.accountOwnerURL;
var CONFIG = _environment.default.CONFIG;
var getAccount = exports.getAccount = function getAccount(auth) {
  var config = Object.assign({}, CONFIG);
  config = _environment.default.ADD_AUTH_HEADER(config, auth);
  return fetch(accountUrl, config).then(function (res) {
    if (res.status === 404 || res.status === 400) {
      //if api is down
      var errorMessage = {
        code: res.status,
        message: 'API is not reachable'
      };
      throw errorMessage;
    } else if (res.status === 200) {
      return res.json();
    } else if (res.error.code !== 0) {
      //api returns a non (404/400/200) error

      var _errorMessage = _objectSpread({}, res.error);
      throw _errorMessage;
    }
  }).catch(function (error) {
    return {
      error: _objectSpread({}, error)
    };
  });
};
var register = exports.register = function register(account) {
  var config = Object.assign({}, CONFIG);
  config.method = 'POST';
  //config.headers = { 'Content-Type': 'application/json; charset=utf-8' };
  return fetch(registerUrl, Object.assign({}, config, {
    body: JSON.stringify(account)
  })).then(function (res) {
    return res.json();
  }).catch(function (error) {
    return {
      code: 1,
      message: error.message
    };
  });
};
var getAccountOwners = exports.getAccountOwners = function getAccountOwners(auth) {
  var config = Object.assign({}, CONFIG);
  config = _environment.default.ADD_AUTH_HEADER(config, auth);
  return fetch(accountOwnersURL, config);
};
var _verifyUser = exports._verifyUser = function _verifyUser(userIdToken, dateTimeToken, emailToken) {
  var config = Object.assign({}, CONFIG);
  var fullUrl = verifyUrl + '/' + userIdToken + '/' + dateTimeToken + '/' + emailToken;
  return fetch(fullUrl, config).then(function (res) {
    return res.json();
  }).catch(function (error) {
    return {
      code: 1,
      message: error.message
    };
  });
};
var _checkUserStatus = exports._checkUserStatus = function _checkUserStatus(emailAddress) {
  var config = Object.assign({}, CONFIG);
  var fullUrl = checkStatusUrl + '/' + emailAddress;
  return fetch(fullUrl, config).then(function (res) {
    return res.json();
  }).catch(function (error) {
    return {
      code: 1,
      message: error.message
    };
  });
};
var _resendEmail = exports._resendEmail = function _resendEmail(emailAddress, auth) {
  var config = Object.assign({}, CONFIG);
  config = _environment.default.ADD_AUTH_HEADER(config, auth);
  var fullUrl = resendEmailUrl + '/' + emailAddress;
  return fetch(fullUrl, config).then(function (res) {
    return res.json();
  }).catch(function (error) {
    return {
      code: 1,
      message: error.message
    };
  });
};
var _changeEmail = exports._changeEmail = function _changeEmail(oldEmail, newEmail, auth) {
  var config = Object.assign({}, CONFIG);
  config.method = 'PUT';
  config.headers = Object.assign({}, config.headers, {
    'Content-Type': 'application/json; charset=utf-8'
  });
  config = _environment.default.ADD_AUTH_HEADER(config, auth);
  return fetch(changeEmailUrl, Object.assign({}, config, {
    body: JSON.stringify({
      oldEmail: oldEmail,
      newEmail: newEmail
    })
  })).then(function (res) {
    if (res.ok) {
      return res.json();
    } else {
      return {
        code: res.status,
        message: res.statusText
      };
    }
  }).catch(function (error) {
    return {
      code: 1,
      message: error.message
    };
  });
};

//Manage Account - Get Profile Information
var getProfileAccount = exports.getProfileAccount = function getProfileAccount(auth) {
  var config = Object.assign({}, CONFIG);
  config = _environment.default.ADD_AUTH_HEADER(config, auth);
  return fetch(profileAccountUrl, config).then(function (res) {
    if (res.status === 200 || res.status === 400) {
      return res.json();
    } else {
      return {
        error: {
          code: res.status,
          message: res.statusText
        }
      };
    }
  }).catch(function (error) {
    return {
      error: {
        code: 1,
        message: error.message
      }
    };
  });
};

//Manage Account - Update Profile Information
var updateProfileAccount = exports.updateProfileAccount = function updateProfileAccount(account, auth) {
  var config = Object.assign({}, CONFIG);
  config.method = 'POST';
  config.headers = Object.assign({}, config.headers, {
    'Content-Type': 'application/json; charset=utf-8'
  });
  config = _environment.default.ADD_AUTH_HEADER(config, auth);
  return fetch(profileAccountUrl, Object.assign({}, config, {
    body: JSON.stringify(account)
  })).then(function (res) {
    if (res.status === 200 || res.status === 400) {
      return res.json();
    } else {
      return {
        error: {
          code: 1,
          message: res.statusText
        }
      };
    }
  }).catch(function (error) {
    return {
      code: 1,
      message: error.message
    };
  });
};

/* start --- new apis to use for updated account settings pages - 12/09/2019 */
var _updateProfile = exports._updateProfile = function _updateProfile(profileInfo, auth) {
  profileInfo.updateType = _constants.UpdateType.PROFILE;
  return updateProfileAccount(profileInfo, auth);
};
var _updatePassword = exports._updatePassword = function _updatePassword(passwordInfo, auth) {
  passwordInfo.updateType = _constants.UpdateType.PASSWORD;
  return updateProfileAccount(passwordInfo, auth);
};
var _updateNotificationSettings = exports._updateNotificationSettings = function _updateNotificationSettings(notificationSettings, auth) {
  notificationSettings.updateType = _constants.UpdateType.NOTIFICATIONS;
  return updateProfileAccount(notificationSettings, auth);
};
var _updateBillingPreference = exports._updateBillingPreference = function _updateBillingPreference(billingSettings, auth) {
  billingSettings.updateType = _constants.UpdateType.PAPERLESS;
  return updateProfileAccount(billingSettings, auth);
};
/* end --- new apis to use for updated account settings pages - 12/09/2019 */